import { Landmark } from "lucide-react";

export function Brand({ compact = false, markOnly = false }: { compact?: boolean; markOnly?: boolean }) {
  return (
    <div className={`brand${compact ? " brand--compact" : ""}`} aria-label="Secret Cabinet">
      <span className="brand__mark" aria-hidden="true">
        <Landmark strokeWidth={2.4} />
      </span>
      {!markOnly ? (
        <span className="brand__words">
          <strong>Secret Cabinet</strong>
          <small>A Xile game night</small>
        </span>
      ) : null}
    </div>
  );
}
